import { FormSkeleton } from '@globaleris/ui.library'
import { List, ListItem, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  list: {
    '& > *': {
      display: 'table'
    }
  }
}))

interface ProfileEditLeftPanelDetailsProps {
  isLoading?: boolean
  code: string
  description?: string
  profileSubtype?: string
  breakdownLevel: string
  toll?: string
  commodity: string
}

export const ProfileEditLeftPanelDetails: React.FC<ProfileEditLeftPanelDetailsProps> = ({
  isLoading = false,
  code,
  description,
  profileSubtype,
  breakdownLevel,
  toll,
  commodity
}) => {
  const classes = useStyles()
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'profiles'])

  return (
    <>
      {isLoading ? (
        <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={3} />
      ) : (
        <>
          <Typography variant="h1" color="primary" noWrap>
            {t('profiles:leftColumn.title')}
          </Typography>
          <List className={classes.list}>
            <ListItem divider disableGutters>
              <Typography variant="h2">{t('profiles:leftColumn.subtitle')}</Typography>
            </ListItem>
            <ListItem divider disableGutters>
              <Typography variant="caption">{t('profiles:leftColumn.captions.code')}</Typography>
              <Typography variant="body2">{code}</Typography>
            </ListItem>
            {description && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('profiles:leftColumn.captions.description')}
                </Typography>
                <Typography variant="body2">{description}</Typography>
              </ListItem>
            )}
            {profileSubtype && (
              <ListItem divider disableGutters>
                <Typography variant="caption">
                  {t('profiles:leftColumn.captions.profileSubtype')}
                </Typography>
                <Typography variant="body2">{profileSubtype}</Typography>
              </ListItem>
            )}
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('profiles:leftColumn.captions.breakdownLevel')}
              </Typography>
              <Typography variant="body2">{breakdownLevel}</Typography>
            </ListItem>
            {toll && (
              <ListItem divider disableGutters>
                <Typography variant="caption">{t('profiles:leftColumn.captions.toll')}</Typography>
                <Typography variant="body2">{toll}</Typography>
              </ListItem>
            )}
            <ListItem divider disableGutters>
              <Typography variant="caption">
                {t('profiles:leftColumn.captions.commodity')}
              </Typography>
              <Typography variant="body2">{commodity}</Typography>
            </ListItem>
          </List>
        </>
      )}
    </>
  )
}
